import { ReactNode } from "react"
import { useReusableWizard } from "./ReusableWizard"
import { ReusableWizardHeader } from "./ReusableWizardHeader"

export type ReusableWizardStepProps = {
  title?: string
  subtitle?: string
  pageNumber?: number
  children: ReactNode
  totalPages?: number
  showHeader?: boolean
}

export const ReusableWizardStep = ({
  title,
  subtitle,
  pageNumber,
  totalPages,
  children,
  showHeader = true,
}: ReusableWizardStepProps) => {
  // Use page state from context but allow override via props
  const { currentPageNumber, totalPages: contextTotalPages } = useReusableWizard()
  pageNumber = pageNumber ?? currentPageNumber
  totalPages = totalPages ?? contextTotalPages

  return (
    <>
      {showHeader && (
        <ReusableWizardHeader
          title={title}
          subtitle={subtitle}
          pageNumber={pageNumber}
          totalPages={totalPages}
        />
      )}
      {children}
    </>
  )
}
